export default __webpack_public_path__ + "static/media/movie-details-page-light.2d6d79d2.png";